module.exports = __webpack_public_path__ + "static/media/mobiwash.55b824d4.png";